import { BackofficeGeneralSettingsController } from './backoffice-general-settings.controller'

function backofficeGeneralSettingsDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/directives/backoffice-general-settings/backoffice-general-settings-directive.html?$$REVISION$$',
    controller: BackofficeGeneralSettingsController
  }
}

export { backofficeGeneralSettingsDirective }
